// extracted by mini-css-extract-plugin
export default {"connect_button":"ConnectionComponent_connect_button__RyTyX"};